import React, { Fragment } from 'react';
import { Query } from 'react-apollo';
import { GET_APPLICATION } from '../../api/application';
import { Alert, Button, Tag } from 'antd';
import Loading from '../Loading';
import 'react-day-picker/lib/style.css';
import './index.css';

function ApplicationDetails({ _id, _handleOperation }) {
  if (!_id) return null;

  return (
    <div>
      <Query
        query={GET_APPLICATION}
        variables={{ _id }}
        fetchPolicy="no-cache"
      >
        {({ loading, error, data }) => {
          if (loading) return <Loading />;
          if (error) {
            return (
              <Alert
                type="error"
                showIcon
                message="Failed to load application details"
                description="Please close this window and try again."
              />
            );
          }
          const { application } = data;
          if (!application) {
            return (
              <Alert
                type="warning"
                showIcon
                message="Application is no longer available"
              />
            );
          }

          const user = application.applicant;
          const identityStatus =
            user && user.identity
              ? { color: 'green', label: 'Verified' }
              : application.type === 'identity' &&
                application.status === 'pending'
              ? { color: 'blue', label: 'Pending verification' }
              : application.type === 'identity' &&
                application.status === 'rejected'
              ? { color: 'red', label: 'Verification rejected' }
              : { color: 'orange', label: 'Not verified' };

          return (
            <div>
              <div className="application-detail-title">Applicant</div>
              {user ? (
                <div
                  style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.2)' }}
                >
                  <div className="application-detail-user">
                    <img
                      className="application-detail-user-avatar"
                      src={user.avatarUrl}
                      alt=""
                    />
                    <div className="application-detail-user-titles">
                      <div className="application-detail-user-details">
                        <div className="application-detail-user-field">
                          {user.nickname || 'Unnamed user'}
                        </div>
                        {user.gender && (
                          <div className="application-detail-user-field">
                            ({user.gender})
                          </div>
                        )}
                      </div>
                      <div className="application-detail-user-id">
                        {user._id}
                      </div>
                    </div>
                  </div>
                  <div className="application-detail-user-identity">
                    <div className="application-detail-user-school">
                      Certification status:{' '}
                      <Tag color={identityStatus.color}>
                        {identityStatus.label}
                      </Tag>
                    </div>
                    <div className="application-detail-user-studentId">
                      School:{' '}
                      {(user.identity || {}).school ||
                        user.school ||
                        application.school ||
                        'Unknown'}
                    </div>
                    {user.identity && (
                      <Fragment>
                        <div className="application-detail-user-studentId">
                          Student ID: {user.identity.studentId || 'Unknown'}
                        </div>
                        {user.identity.name && (
                          <div className="application-detail-user-studentId">
                            Name: {user.identity.name}
                          </div>
                        )}
                      </Fragment>
                    )}
                    {user.phone && (
                      <div className="application-detail-user-studentId">
                        Phone: {user.phone}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <Alert
                  type="warning"
                  showIcon
                  message="Applicant account is unavailable"
                  description="The user may have deleted their account. The application record is still available for review."
                />
              )}

              <div className="application-detail-title">Application</div>
              <div className="application-detail-application">
                <a
                  className="application-detail-img"
                  href={application.imgUrl || application.profileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={application.imgUrl || application.profileUrl}
                    alt=""
                  />
                </a>
                <div className="application-detail-details">
                  <div className="application-detail-field">
                    {application.title || application.school || 'No title'}
                  </div>
                  <div className="application-detail-field">
                    {application.desc || application.studentId || 'No desc'}
                  </div>
                  <div className="application-detail-field">
                    status: {application.status}
                  </div>
                </div>
              </div>

              {application.status === 'pending' &&
                <Fragment>
                  <div className="application-detail-title">Actions</div>
                  <div className="application-detail-actions-container">
                    <Button
                      icon="check"
                      type="primary"
                      // disabled={application.status === 'authorized'}
                      onClick={() => _handleOperation('Authorize')}
                    >
                      Authorize
                    </Button>
                    <Button
                      icon="delete"
                      type="danger"
                      className="carton-list-modal-button"
                      style={{ marginLeft: '10px' }}
                      // disabled={application.status === 'rejected'}
                      onClick={() => _handleOperation('Reject')}
                    >
                      Reject
                    </Button>
                  </div>
                </Fragment>
              }
            </div>
          );
        }}
      </Query>
    </div>
  );
}

export default ApplicationDetails;
